









import { Vue, Component, Prop } from 'vue-property-decorator'

import 'semantic-ui-css/components/segment.min.css'
import 'semantic-ui-css/components/grid.min.css'

interface TierColor {
  [index: number]: string[]
}

const tierColors: TierColor = {
  0: ['#404040', '#4d4d4d', '#ffffff', '#666666'],
  1: ['#a674be', '#b286c6', '#d375ff', '#c3a1d3'],
  2: ['#237651', '#29895e', '#00cc00', '#31a36f'],
  3: ['#cdb632', '#d2bd46', '#ff6600', '#d9c660'],
  4: ['#2cc9ed', '#43cfef', '#3333ff', '#5ed6f1'],
  5: ['#815e18', '#976e1c', '#ffff00', '#bf8b23'],
  6: ['#3c1127', '#501634', '#ff0000', '#671d43']
}

@Component
export default class LCDonor extends Vue {
  @Prop(String) readonly name!: string
  @Prop(String) readonly avatar!: string
  @Prop(Number) readonly tier!: number
  colors: String[] = tierColors[this.tier]
}
